module.exports = __webpack_public_path__ + "img/1557614087029989378.35f5b086.png";